define('core/time',[],function () {
    'use strict';

    var ISO_8601 = 'YYYY-MM-DDTHH:mm:ssZ';

    function assureTzOffset(createdAt) {
        return createdAt.indexOf('+') >= 0 ? createdAt : createdAt + '+00:00';
    }

    return {
        ISO_8601: ISO_8601,
        assureTzOffset: assureTzOffset,
    };
});

